import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardSummary = ({ summary }) => {
  const summaryCards = [
    {
      id: 'total',
      label: 'Total Registrations',
      value: summary?.totalRegistrations,
      icon: 'ClipboardList',
      color: 'primary',
      bgColor: 'bg-primary/10',
    },
    {
      id: 'draft',
      label: 'Draft',
      value: summary?.draftCount,
      icon: 'FileEdit',
      color: 'muted-foreground',
      bgColor: 'bg-muted',
    },
    {
      id: 'submitted',
      label: 'Submitted',
      value: summary?.submittedCount,
      icon: 'Send',
      color: 'primary',
      bgColor: 'bg-primary/10',
    },
    {
      id: 'approved',
      label: 'Approved',
      value: summary?.approvedCount,
      icon: 'CheckCircle',
      color: 'success',
      bgColor: 'bg-success/10',
    },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {summaryCards?.map((card) => (
          <div
            key={card?.id}
            className="card hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 lg:w-12 lg:h-12 ${card?.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon name={card?.icon} size={20} color={`var(--color-${card?.color})`} />
              </div>
              <div className="flex-1">
                <p className="text-2xl lg:text-3xl font-bold text-foreground">
                  {card?.value}
                </p>
                <p className="text-xs lg:text-sm text-muted-foreground">
                  {card?.label}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="card bg-warning/10 border-warning/20">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-warning/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-foreground mb-2">
              Registration Limit
            </h4>
            <p className="text-sm text-muted-foreground mb-3">
              You have used {summary?.totalRegistrations} out of 3 available registration slots (1 each in U14 Boys, U16 Boys, and U15 Girls).
              {summary?.remainingSlots > 0 && ` You can create ${summary?.remainingSlots} more registration(s).`}
            </p>
            {summary?.remainingSlots === 0 && (
              <div className="bg-warning/20 rounded-md p-2">
                <p className="text-xs text-warning-foreground font-medium">
                  You have reached the maximum registration limit. Please contact support if you need additional slots.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card bg-primary/5 border-primary/20">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-foreground mb-2">
              Important Deadlines
            </h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Registration Closes:</span>
                <span className="text-foreground font-medium">13th February 2026</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Tournament Starts:</span>
                <span className="text-foreground font-medium">19th February 2026</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSummary;